import { Component, OnInit } from '@angular/core';
import { PoliciesByBaseType, PoliciesContextService } from '@core/services/context/policies-context.service';
import { AuthMirrorService } from '@core/services/core/auth/auth-mirror.service';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';
import { GenesysChatHelperService } from '@core/services/helpers/genesys-chat-helper.service';
import { GenesysChatService } from '@core/services/http-services/genesys-chat.service';
import { IdentifyClientResponse } from '@models/genesys-chat';
import { POLICY_BASE_TYPES } from '@models/policy';
import { getFullName } from '@models/user';
import { jsonClone } from '@utils/utils';
import { DeviceDetectorService } from 'ngx-device-detector';

declare const document: any;

declare function Genesys(c: string, f: string, params?: any, resolve?: any, reject?: any): any;
declare function initGenesys(deploymentId: string): any;

@Component({
  selector: 'app-genesys-chat',
  templateUrl: './genesys-chat.component.html',
  styleUrls: ['./genesys-chat.component.scss'],
})

export class GenesysChatComponent implements OnInit {
  clientIdentified: IdentifyClientResponse;
  isAvailable = false;
  onlyPolicyCar: boolean;
  genesysChatIcon: string = null;

  constructor(
    private chatHelper: GenesysChatHelperService,
    private genesysChatService: GenesysChatService,
    private authMirror: AuthMirrorService,
    private deviceService: DeviceDetectorService,
    private mmobile: MMobileHelperService,
    private policiesContext: PoliciesContextService,
  ) { }

  async ngOnInit() {
    if (!document.getElementById('iFrameName')) {
      this.identifyClient();
    }
  }

  private identifyClient() {
    this.genesysChatService.identifyClient().subscribe({
      next: (response) => {
        this.clientIdentified = response;
        this.checkOnlyPolicyCar();
      },
      error: (error) => {
        document.getElementsByTagName('app-genesys-chat')[0]?.remove();
      }
    });
  }

  checkOnlyPolicyCar() {
    this.policiesContext.getPoliciesByBaseTypeObs().subscribe(
      {
        next: (res: PoliciesByBaseType) => {
          let policiesByBaseType = [];
          policiesByBaseType = jsonClone(res);
          const checkUserPolicies = p => policiesByBaseType[p]?.length > 0;
          const listUserPoliciesTypes = POLICY_BASE_TYPES.filter(checkUserPolicies);
          const checkOnlyPolicyCar = listUserPoliciesTypes?.length === 1 && listUserPoliciesTypes[0] === 'car';

          this.onlyPolicyCar = this.clientIdentified?.managerId ? false : checkOnlyPolicyCar;
          this.checkChatAccess();
        }
      }
    );
  }

  checkChatAccess() {
    if (this.clientIdentified?.managerId || this.onlyPolicyCar) {
      this.genesysChatIcon = this.clientIdentified.status === 0
        ? 'assets/images/client-area/genesys-chat-icon-disabled.svg'
        : 'assets/images/client-area/genesys-chat-icon-available.svg';
    } else {
      this.genesysChatIcon = null;
    }
  }

  public loadGenesysChat() {
    if (this.isButtonDisabled()) {
      return;
    }

    const deploymentId = this.mmobile.getCustomConfigData('genesysChatDeploymentId');
    initGenesys(deploymentId);

    const genesysParams = this.getGenesysParams();
    const departament = this.onlyPolicyCar ? 'AUTOS' : this.clientIdentified.managerId;
    this.genesysChatService.checkAvailability(departament).subscribe({
      next: (response) => {
        if (response.available) {

          Genesys('subscribe', 'Messenger.ready', () => {
            this.genesysChatIcon = null;

            Genesys('subscribe', 'Launcher.ready', () => {
              Genesys('command', 'Database.set', genesysParams);
              Genesys('command', 'Messenger.open');
            });

          });

        } else {
          this.chatHelper.showModalInfo(response);
        }
      },
      error: () => {
        this.chatHelper.showModalError();
      }
    });
  }

  private isButtonDisabled(): boolean {
    return this.genesysChatIcon.includes('disabled');
  }

  private getGenesysParams() {
    const { user } = this.authMirror.authService.getState();

    return {
      messaging: {
        customAttributes: {
          document: user.documentNumber,
          name: getFullName(user),
          dept: this.onlyPolicyCar ? 'METS-CHAT-AUTOS' : 'METS-CHAT-REMOTOS',
          nuuma: this.clientIdentified.managerId || null,
          PLATAFORMA: this.deviceService.os,
          NAVEGADOR: this.deviceService.browser
        }
      }
    };
  }
}
